import { useMemo } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { LapsedPetParentTasks } from '@/components/Workflows/LapsedPetParentTasks';

// Mounts the federated task list standalone so it can be exercised without the Flow host. The
// host owns the assignee filter; here it comes from the query string, e.g.
// `/dev/Tasks?assigneeIds=u1,u2&unassigned=true`.
const searchSchema = z.object({
  view: z.enum(['active', 'completed']).default('active'),
  assigneeIds: z.string().optional(),
  unassigned: z.boolean().optional(),
});

export const Route = createFileRoute('/dev/Tasks')({
  validateSearch: searchSchema,
  component: RouteComponent,
});

function RouteComponent() {
  const { view, assigneeIds, unassigned } = Route.useSearch();
  // A stable array, or the list resets to page 1 on every render.
  const filterAssigneeIds = useMemo(() => assigneeIds?.split(',').filter(Boolean), [assigneeIds]);
  return (
    <LapsedPetParentTasks
      view={view}
      filterAssigneeIds={filterAssigneeIds}
      filterIncludeUnassigned={unassigned}
    />
  );
}
